import englishMessages from 'ra-language-english';
import common from './common';
import auth from './auth';
import dashboard from './dashboard';
import leads from './leads';
import settings from './settings';
import hotels from './hotels';
import hotelChains from './hotelChains';
import catalogs from './catalogs';
import backups from './backups';

const en = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    action: {
      ...englishMessages.ra.action,
      add_filter: 'Add filter',
      clear_input_value: 'Clear field',
      close: 'Close',
    },
    page: {
      ...englishMessages.ra.page,
      dashboard: 'Dashboard',
    },
  },
  common,
  auth,
  dashboard,
  fields: {
    name: 'Name',
    description: 'Description',
    status: 'Status',
    email: 'Email',
    createdAt: 'Created at',
    updatedAt: 'Last updated',
  },
  resources: {
    leads,
    settings,
    hotels,
    'hotel-chains': hotelChains,
  },
  catalogs,
  backups,
  user: {
    profile: 'Profile',
    settings: 'Settings',
    change_password: 'Change Password',
  },
  pages: {
    login: {
      subtitle: 'Sign in to start',
      login_button: 'Sign In',
      forgot_password: 'Forgot your password?',
    },
    dashboard: {
      no_data: 'No results found',
      no_data_description: 'No data available at this time',
    },
  },
  validation: common.validation,
  notifications: common.notifications,
};

export default en;
